import {
  callGet,
  callPost,
  callPutById,
  callDelete,
} from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const getAllCoupons = async (token) => {
  return await callGet(`${REQ.COUPON.GET_ALL_COUPON}`, token);
};

export const createCoupon = async (data, token) => {
  return await callPost(REQ.COUPON.SAVE_DATA, data, token);
};

export const updateSingleCoupon = async (data, token) => {
  return await callPutById(
    `${REQ.COUPON.UPDATE_COUPON_BOOK}/${data.id}`,
    data,
    token
  );
};

export const deleteSingleCoupon = async (data, token) => {
  return await callDelete(
    `${REQ.COUPON.DELETE_COUPON_BOOK}/${data.id}`,
    data,
    token
  );
};
